export const API_URL='https://api.parassolutions.in/api'
// export const API_URL='https://piramal.legalalerts.in/api'
// export const API_URL='http://localhost:3000/api'
// export const API_URL='http://13.233.148.206:3000/api'
// export const API_URL='https://test-piramal.legalalerts.in/api"
// export const API_URL='https://piramalbackend.parassolutions.in/api'
// export const API_URL='https://13.233.148.206:3000/api'
